import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-upload-progress',
  templateUrl: './upload-progress.component.html',
  styleUrls: ['./upload-progress.component.scss']
})
export class UploadProgressComponent implements OnInit {
  @Input() progress;
file: any;
  


constructor() {
// this.progress = 0;
   }

  ngOnInit(): void {
  }

}
